import Api from "./fnapi-client";

function formatDate(date) {
  return (date.substr(5,2)+"."+date.substr(8,2)+"."+date.substr(2,2));
}

export default {

  getVersion: function(state) {
    return Api.get("sdk/version").then((response) => {
      state.setState({
        android_release_version: response.data.android ? response.data.android.version : "",
        android_release_date: response.data.android ? formatDate(response.data.android.date) : "",
        ios_release_version: response.data.ios ? response.data.ios.version : "",
        ios_release_date: response.data.ios ? formatDate(response.data.ios.date) : "",
        server_java_release_version: response.data.server_java ? response.data.server_java.version : "",
        server_java_release_date: response.data.server_java ? formatDate(response.data.server_java.date) : "",
        server_c_release_version: response.data.server_c ? response.data.server_c.version : "",
        server_c_release_date: response.data.server_c ? formatDate(response.data.server_c.date) : "",
        zoom_web_release_version: response.data.zoom_web ? response.data.zoom_web.version : "",
        zoom_web_release_date: response.data.zoom_web ? formatDate(response.data.zoom_web.date) : "",
        zoom_web_angular_sample_release_date: response.data.zoom_web_angular_sample ? formatDate(response.data.zoom_web_angular_sample.date) : "",
        zoom_web_react_js_sample_release_date: response.data.zoom_web_react_js_sample ? formatDate(response.data.zoom_web_react_js_sample.date) : "",
        zoom_web_react_typescript_sample_release_date: response.data.zoom_web_react_typescript_sample ? formatDate(response.data.zoom_web_react_typescript_sample.date) : "",
        server_rest_release_version: response.data.server_rest ? response.data.server_rest.version : "",
        server_rest_release_date: response.data.server_rest ? formatDate(response.data.server_rest.date) : "",
        server_docker_release_version: response.data.server_docker ? response.data.server_docker.version : "",
        server_docker_release_date: response.data.server_docker ? formatDate(response.data.server_docker.date) : "",
        server_standard_release_version: response.data.server_standard ? response.data.server_standard.version : "",
        server_standard_release_date: response.data.server_standard ? formatDate(response.data.server_standard.date) : "",
        server_dashboard_release_version: response.data.server_dashboard ? response.data.server_dashboard.version : "",
        server_dashboard_release_date: response.data.server_dashboard ? formatDate(response.data.server_dashboard.date) : ""
      })
    })
  },

  download: function(platformString) {
    return Api.get("sdk/download").then((response) => {
      var release = response.data[platformString];
      if (!release)
        throw response;
      window.location = release;
      }).catch( (error) => {
        throw error
      })
  }
};



// WEBPACK FOOTER //
// ./src/js/utilities/zoom-handler.jsx